import classes from './Logs.module.css';

const Logs = () => {
    return (
        <div className={classes.wrapper}>
        </div>
    )
}

export default Logs;